const generateReferenceID = () => {
  const uniqueId = new Date().valueOf();
  return uniqueId.toString();
};

export default generateReferenceID;
